import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { Avatar } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/i18n-react';
import { RecipientInfo as RecipientInfoPropType } from '../../context/propTypes';
import { StaticContextProvider } from '../../context/contexts/static';
import RecipientInfo from '../RecipientInfo';

import classes from './style.module.scss';

const ContactSellerButton = ({ recipientInfo, className, onClick = noop, isMobile, isAssistantActive = false }) => {
    const { username, profilePhoto, isOnline } = recipientInfo;

    const wrapperClasses = classNames(
        classes.contactSellerButton,
        'box-shadow-z5',
        className
    );

    return (
        <StaticContextProvider recipientInfo={recipientInfo} showSpokenLanguages={false}>
            <div className={wrapperClasses} onClick={onClick} data-testid="contact-seller-button">
                {isMobile ?
                    (<>
                        <span data-testid="avatar">
                            <Avatar containerClassName={classes.avatar}
                                username={username}
                                size={32}
                                src={profilePhoto}
                                showOnlineIndicator
                                isOnline={isOnline}/>
                        </span>
                        <span className={classNames('p-l-12', 'co-grey-1100', 'text-semi-bold')}>
                            <I18n k="send_message.message"/>
                        </span>
                    </>):
                    (
                        <RecipientInfo className="flex-items-center"
                            responseTimeClassName="tbody-7"
                            messageSellerClassName={classNames('tbody-5', 'text-semi-bold')}
                            avatarClassName={classes.avatar}
                            isAssistantActive={isAssistantActive}/>
                    )
                }
            </div>
        </StaticContextProvider>
    );
};

ContactSellerButton.propTypes = {
    isMobile: PropTypes.bool,
    className: PropTypes.string,
    onClick: PropTypes.func,
    recipientInfo: RecipientInfoPropType,
    isAssistantActive: PropTypes.bool
};

export default ContactSellerButton;
